import { createStyles } from '@mantine/styles';


export default createStyles((theme: {
    colors: { [x: string]: any[] };
    white: string;
    fontSizes: any;
    spacing: any;
    radius: any;
    fn: any;
    shadows: any;
    colorScheme: any;
}) => ({

    paper: {
        // margin: '0 auto',
        textAlign: 'justify',
        fontSize: 13,
        maxWidth: '100%',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: theme.colorScheme === 'dark' ? theme.colors.gray[8] : theme.colors.gray[3],
        boxShadow: theme.shadows.sm,
        color: theme.colorScheme === 'dark' ? theme.colors.gray[0] : theme.colors.gray[7],
    },

    progress: {
        textAlign: 'center',
    },

    bookNowButton: {
        background: theme.fn.linearGradient(30, theme.colors.orange[5], theme.colors.yellow[5]),
        textTransform: 'uppercase',
        fontWeight: 500,
        letterSpacing: 1,

        '&[data-disabled]': {
            background: theme.colorScheme === 'dark' ? theme.colors.gray[8] : theme.colors.gray[3],
        },
    },

    readyToBookText: {
        flex: 2,
        textAlign: 'center',
        textTransform: 'uppercase',
        paddingTop: 10,
        paddingBottom: 10,
        borderColor: theme.colorScheme === 'dark' ? theme.colors.gray[8] : theme.colors.gray[4],
        fontSize: 13,
        maxWidth: '100%',
        borderWidth: 1,
        borderStyle: 'solid',
        borderRadius: theme.radius.xs
    },

}));
